import type { CSSProperties } from 'react';
import { forwardRef } from 'react';

import type { StackProps as MantineStackProps } from '@mantine/core';
import { createPolymorphicComponent, Stack as MantineStack } from '@mantine/core';

import { omitUndefined } from '@/new_src/view/components/utils/omitUndefined';
import { resolveColorTokens } from '@/new_src/view/components/utils/resolveColorTokens';

type ExtraStyleProps = {
  radius?: CSSProperties['borderRadius'];
  boxSizing?: CSSProperties['boxSizing'];
  overflow?: CSSProperties['overflow'];
  zIndex?: CSSProperties['zIndex'];
  bdb?: CSSProperties['borderBottom'];
  boxShadow?: CSSProperties['boxShadow'];
};

type StackProps = MantineStackProps & ExtraStyleProps;

const _Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ radius, boxSizing, overflow, zIndex, bdb, boxShadow, style, ...props }, ref) => {
    return (
      <MantineStack
        ref={ref}
        style={[
          omitUndefined({
            borderRadius: radius,
            boxSizing,
            overflow,
            zIndex,
            borderBottom: typeof bdb === 'string' ? resolveColorTokens(bdb) : bdb,
            boxShadow,
          }),
          style,
        ]}
        {...props}
      />
    );
  }
);

_Stack.displayName = 'Stack';

export const Stack = createPolymorphicComponent<'div', StackProps>(_Stack);
